module.exports = __webpack_public_path__ + "static/media/Arcade_6432.e16d19ac.jpg";